import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { LuPanelLeft } from "react-icons/lu";
import { AppSidebar } from "../sidebar/AppSidebar";
import { SIDEBAR_MARGINS } from "../sidebar/sidebarConstants";

const COLLAPSE_STORAGE_KEY = "app-sidebar-collapsed";
const MOBILE_BREAKPOINT = 768;
const COLLAPSE_BREAKPOINT = 1024;

const AppLayout = ({ navConfig, defaultCollapsed = false }) => {
  const [collapsed, setCollapsed] = useState(() => {
    if (typeof window === "undefined") return defaultCollapsed;
    // Map and similar full-bleed views start collapsed so the canvas gets maximum space.
    if (defaultCollapsed) return true;
    return localStorage.getItem(COLLAPSE_STORAGE_KEY) === "true";
  });
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth < MOBILE_BREAKPOINT;
  });
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(COLLAPSE_STORAGE_KEY, String(collapsed));
  }, [collapsed]);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const mobile = width < MOBILE_BREAKPOINT;
      setIsMobile(mobile);

      if (width < COLLAPSE_BREAKPOINT) {
        setCollapsed(true);
      }

      if (!mobile) {
        setMobileOpen(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleCollapse = () => {
    if (isMobile) {
      setMobileOpen((prev) => !prev);
      return;
    }
    setCollapsed((prev) => !prev);
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      <AppSidebar
        navConfig={navConfig}
        collapsed={collapsed}
        toggleCollapse={toggleCollapse}
        isMobile={isMobile}
        mobileOpen={mobileOpen}
        closeMobile={() => setMobileOpen(false)}
      />
      {isMobile ? (
        <button
          type="button"
          onClick={() => setMobileOpen(true)}
          className="fixed left-4 top-4 z-30 rounded-md border border-gray-200 bg-white p-2 text-gray-700 shadow-md"
          aria-label="Open sidebar"
        >
          <LuPanelLeft size={20} />
        </button>
      ) : null}
      <main
        className={`min-w-0 flex-1 flex flex-col min-h-screen bg-gray-50 transition-all duration-300 ease-in-out ${
          isMobile ? "ml-0" : (collapsed ? SIDEBAR_MARGINS.COLLAPSED : SIDEBAR_MARGINS.EXPANDED)
        }`}
        style={{ "--app-sidebar-offset": isMobile ? "0px" : `${collapsed ? 80 : 270}px` }}
      >
        <Outlet />
      </main>
    </div>
  );
};

export default AppLayout;
